import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectLanguage, selectPinterestTagId } from 'root-redux/selects/common'
import { selectEmail, selectUUID } from 'root-redux/selects/user'

import { getSha256Hash } from 'helpers/getSha256Hash'

import { eventLogger } from 'services/eventLogger.service'

import { useCookieConsentAnswer } from './useCookieConsentAnswer'

export const useStartSession = (): void => {
  const dispatch = useDispatch()
  const uuid = useSelector(selectUUID)
  const language = useSelector(selectLanguage)
  const email = useSelector(selectEmail)
  const pinterestTagId = useSelector(selectPinterestTagId)
  const { canUseAdvertising } = useCookieConsentAnswer()

  useEffect(() => {
    eventLogger.logSessionStarted(language)
  }, [dispatch, language])

  useEffect(() => {
    if (!uuid || !pinterestTagId || !canUseAdvertising) return

    window.pintrk &&
      window.pintrk('track', 'pagevisit', {
        external_id: getSha256Hash(uuid),
      })
  }, [uuid, pinterestTagId, canUseAdvertising])

  useEffect(() => {
    if (uuid) {
      window.fbq('track', 'ViewContent', {}, { eventID: uuid })
      window.rdt &&
        window.rdt('track', 'ViewContent', {
          email,
          externalId: uuid,
        })
    }
  }, [uuid, email])
}
